import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Typography, Box, Button, Alert } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'

import { ReactComponent as ArrowRight } from '../../../assets/icons/arrow-right.svg'
import useTranslations from '../../../i18n/useTranslations'
import AddressForm from '../../../ui/views/shippingSend/AddressSection/AddressForm'
import useStyles from '../AddressBook/styles'

const AddressEdition = props => {
  const { onCancel, isSubmitting, formErrors, ...restProps } = props
  const classes = useStyles()
  const t = useTranslations()

  return (
    <Box>
      <Typography
        variant="h2"
        className={clsx('secondaryTitle', 'decorator', classes.title)}
      >
        {t('shipping-send-form:address-edition')}
      </Typography>
      <AddressForm {...restProps} isSmall />
      {formErrors ? (
        <Box className={classes.formErrors}>
          {formErrors?.map(key => (
            <Alert key={key} severity="error">
              {t(key)}
            </Alert>
          ))}
        </Box>
      ) : null}

      <Box className={classes.actionButtons}>
        <Button
          type="button"
          size="small"
          variant="outlined"
          onClick={onCancel}
        >
          {t('action:cancel')}
        </Button>
        <LoadingButton
          className={classes.mainButton}
          type="submit"
          size="small"
          disabled={
            isSubmitting || Boolean(Object.keys(props.fieldErrors)?.length)
          }
          loading={isSubmitting}
          loadingPosition="end"
          endIcon={<ArrowRight />}
        >
          {t('action:save-changes')}
        </LoadingButton>
      </Box>
    </Box>
  )
}

AddressEdition.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onChangeAutocompleteAddress: PropTypes.func,
  fieldErrors: PropTypes.object,
  currentStep: PropTypes.string,
  onCancel: PropTypes.func,
  isSubmitting: PropTypes.bool,
  formErrors: PropTypes.object,
}

export default AddressEdition
